// Quote(KAM dashboard) API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type KAMDashboardRequests = {
    domainName: string,
    getUpcomingQuotes: RequestConfigFunction<Record<string, any> | undefined>,
    getToBeCompletedQuotes: RequestConfigFunction<Record<string, any> | undefined>,
    getCompletedQuotes: RequestConfigFunction<Record<string, any> | undefined>,
}

const kamDashboardRequests: KAMDashboardRequests = {
    domainName: 'KAMDashboard',
    getUpcomingQuotes: (params) => {
        return {
            url: 'quote/filter-request/kamdashboard-upcoming-quotes',
            method: 'POST',
            ...params,
        }
    },
    getToBeCompletedQuotes: (params) => {
        return {
            url: 'quote/filter-request/kamdashboard-to-be-completed',
            method: 'POST',
            ...params,
        }
    },
    getCompletedQuotes: (params) => {
        return {
            url: 'quote/filter-request/kamdashboard-completed',
            method: 'POST',
            ...params,
        }
    },
}

export default kamDashboardRequests
